import { render, staticRenderFns } from "./NewSales.vue?vue&type=template&id=1ff9259c&scoped=true&"
import script from "./NewSales.vue?vue&type=script&lang=js&"
export * from "./NewSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff9259c",
  null
  
)

export default component.exports